import { observer } from "mobx-react";
import React, { useEffect } from "react";
import {
  Text,
  Loader,
  Box,
  Stack,
  Center,
  Divider,
  Button,
  Select,
  ActionIcon,
  Group,
} from "@mantine/core";
import { BobsWorkspace } from "../stores/BobsWorkspace";
import { BOB_MODALS, BOB_PAGES } from "../helpers/constants";
import { IconEdit, IconInfoCircle } from "@tabler/icons-react";
import Receive from "./receive";
import ReceiveOnchain from "./receiveOnchain";
import BobModals from "./modals/BobModals";
import Send from "./send";
import SendOnchain from "./sendOnchain";
import SendUsdt from "./sendUsdt";
import GiftCard from "./giftCard";
import { PayAttempt } from "../stores/PayAttempt";
import PayAttempts from "./payAttempts";
import OurInvoices from "./ourInvoices";

import PlatformCredits from "./platformCredits";
import Spreadsheet from "./spreadSheet";
import TransactionsList from "./transactionsList";
import SelectBob from "./details/selectBob";
import { NumericKeypad } from "./details/numericKeypad";

import BobHome from "./details/bobHome";
import TopButtons from "./topButtons";
import HoldInvoices from "./holdInvoices";
import HoldInvoiceBanner from "./details/holdInvoiceBanner";

const Bob = observer(({ bobsWorkspace }: { bobsWorkspace: BobsWorkspace }) => {
  const selectedBob = bobsWorkspace.selectedBob;
  return (
    <Stack>
      <TopButtons bobsWorkspace={bobsWorkspace} />
      <HoldInvoiceBanner bobsWorkspace={bobsWorkspace} />

      {selectedBob.openPage == BOB_PAGES.HOME && (
        <>
          <BobHome bobsWorkspace={bobsWorkspace} />
        </>
      )}

      {selectedBob.openPage === BOB_PAGES.RECEIVE && (
        <Receive bobsWorkspace={bobsWorkspace} />
      )}
      {selectedBob.openPage === BOB_PAGES.RECEIVE_ONCHAIN && (
        <ReceiveOnchain bobsWorkspace={bobsWorkspace} />
      )}
      {selectedBob.openPage === BOB_PAGES.HOLD_INVOICES && (
        <HoldInvoices bobsWorkspace={bobsWorkspace} />
      )}
      {selectedBob.openPage === BOB_PAGES.SEND && (
        <Send bobsWorkspace={bobsWorkspace} />
      )}
      {selectedBob.openPage === BOB_PAGES.SEND_ONCHAIN && (
        <SendOnchain bobsWorkspace={bobsWorkspace} />
      )}
      {/* DISABLED: Send USDT (Solana) is turned off. See topButtons.tsx and
          config/routes.rb. */}
      {false && selectedBob.openPage === BOB_PAGES.SEND_USDT && (
        <SendUsdt bobsWorkspace={bobsWorkspace} />
      )}
      {selectedBob.openPage === BOB_PAGES.GIFT_CARD && (
        <GiftCard bobsWorkspace={bobsWorkspace} />
      )}

      {selectedBob.openPage === BOB_PAGES.TRANSACTIONS_LIST && (
        <TransactionsList bobsWorkspace={bobsWorkspace} />
      )}

      <BobModals bob={selectedBob} />
    </Stack>
  );
});

export default Bob;
